module.exports = __webpack_public_path__ + "img/GoEnterTicket@2x.73180601.png";